import Slide from '@/components/shared/Slide';
import GoNoGoBadge from '@/components/shared/GoNoGoBadge';
import {
  Table,
  TableHeader,
  TableBody,
  TableHead,
  TableRow,
  TableCell,
} from '@/components/ui/table';
import { sortByPriority } from '@/lib/scoring';
import type { GrantProgram, ViewMode } from '@/types/roadmap.types';

interface Props {
  programs: GrantProgram[];
  mode: ViewMode;
}

export default function NotPrioritizingSlide({ programs, mode }: Props) {
  const deferred = sortByPriority(
    programs.filter(
      (p) =>
        p.go_no_go === 'conditional' ||
        p.go_no_go === 'monitor' ||
        p.go_no_go === 'no_go',
    ),
  );

  if (deferred.length === 0) return null;

  return (
    <Slide mode={mode} wide>
      <div className="w-full max-w-[1400px] mx-auto">
        <div className="px-4">
          <p className="text-xs font-semibold uppercase tracking-[0.2em] text-primary mb-3">
            Executive Decision Summary
          </p>
          <h2 className="text-3xl sm:text-4xl font-bold tracking-tight text-foreground mb-6 print:mb-3 print:text-[16pt]">
            Not Prioritizing Now
          </h2>
        </div>

        <Table className="table-fixed">
          <TableHeader>
            <TableRow className="border-b-2 border-primary/10 hover:bg-transparent">
              <TableHead className="w-[38%] print:text-[7pt]">Program</TableHead>
              <TableHead className="w-[49%] print:text-[7pt]">Reason</TableHead>
              <TableHead className="w-[13%] px-2 text-center print:text-[7pt] print:px-1">
                Status
              </TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {deferred.map((p) => (
              <TableRow key={p.id}>
                <TableCell className="font-medium w-[38%] print:text-[7pt] print:py-1.5">
                  <div className="leading-snug">{p.program_name}</div>
                  <div className="text-[10px] text-muted-foreground font-normal leading-snug print:text-[6pt]">
                    {p.grantor}
                  </div>
                </TableCell>
                <TableCell className="text-xs text-muted-foreground w-[49%] print:text-[7pt] print:py-1.5">
                  <div className="line-clamp-3">
                    {p.primary_blocker ?? p.key_risks?.[0] ?? '—'}
                  </div>
                </TableCell>
                <TableCell className="w-[13%] px-2 text-center whitespace-nowrap print:px-1">
                  <GoNoGoBadge value={p.go_no_go} />
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>
    </Slide>
  );
}
